import { gql } from '@apollo/client';

/** Response shape from `getScriptingAbility` — backend decrypts using masterPassword */
export interface ScriptingAbilityResponse {
  status: boolean;
  /** When `profile.*` is used (e.g. Office 365 / Teams) */
  recording?:
    | {
        username?: string;
        password?: string;
      }
    | string;
  scriptInjection?: string;
  secretTwoFA?: string;
  message?: string;
}

/** Apollo query result type */
export interface GetScriptingAbilityResult {
  getScriptingAbility: ScriptingAbilityResponse | null;
}

/** Apollo query variables */
export interface GetScriptingAbilityVariables {
  assetId: string;
  masterPassword?: string;
  teamId?: string;
}

/**
 * Decrypt scripting-ability credentials for an asset.
 * Backend decrypts AES-encrypted `profile.password` / `profile.username` using
 * the provided `masterPassword` (when `asset.isPasswordMaster === true`).
 * Returns null / { status: false, message } on failure.
 */
export const GET_SCRIPTING_ABILITY = gql`
  query GetScriptingAbility($assetId: String!, $masterPassword: String, $teamId: String) {
    getScriptingAbility(assetId: $assetId, masterPassword: $masterPassword, teamId: $teamId)
  }
`;
